module.exports = __webpack_public_path__ + "static/media/ONGC_F1.28f2669a.txt";